import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./Pages/LandingPage/LandingPage";
import Forgot from "./Pages/Forgot/Forgot";
import Login from "./Pages/Login/Login";
import Items from "./Pages/Items/Items";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Category from "./Pages/Category/Category";
import CreateItems from "./component/CreateItems/CreateItems";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getLoginStatus, getUser } from "./redux/features/auth/AuthSlice";
import Setting from "./Pages/Setting/Setting";
import CreateUser from "./component/CreateUser/CreateUser";
import ChangePassword from "./component/Change Password/ChangePassword";
import EditUser from "./component/Edit user/EditUser";
import Reset from "./Pages/Reset/Reset";
import EditItem from "./component/EditItem/EditItem";
import Sale from "./Pages/Sale/Sale";
import ItemByCategory from "./component/ItemByCategory/ItemByCategory";
import Receipt from "./Pages/Receipt/Receipt";
import CompletingOrder from "./Pages/Completing Order/CompletingOrder";
import { AdminCashier, AdminCashierCounter, OnlyAdmin } from "./Protect/HiddenLink";
// import OrderType from "./component/OrderType/OrderType";
import User from "./Pages/User/User";
import Ingredient from "./Pages/Ingredient/Ingredient";
import Table from "./Pages/Table/Table";
import TableNo from "./component/TableNo/TableNo";
import Reports from "./Pages/Reports/Reports";
import Expenses from "./Pages/Expenses/Expenses";
import Cashes from "./Pages/Cash In/Cashes";
import Waiter from "./Pages/Waiter/Waiter";
import Purchase from "./Pages/Purchase/Purchase";
import AddPurchase from "./component/AddPurchase/AddPurchase";
import CreatePurchase from "./component/Purchase/CreatePurchase";
import CreateInventoryAdjustment from "./component/Create Inventory Adjustment/CreateInventoryAdjustment";
import UnitOfMeasure from "./Pages/UnitOfMeasure/UnitOfMeasure";
import ExpenseItems from "./Pages/Expense Item/expenseItems";
import KitchenReceipt from "./Pages/Kitchen Receipt/kitchenReceipt";
import PublicRoute from "./Protect/PublicRoute";
import ProtectedRoute from "./Protect/ProtectedRoute";

axios.defaults.withCredentials = true;

function App() {
  //disable the inspect mode
  // useEffect(() => {
  //   const disableRightClick = (e) => e.preventDefault();

  //   const handleKeyDown = (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && e.key === "I") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "C") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "J")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   const detectContextMenu = (e) => {
  //     e.preventDefault();
  //     console.log("Right-click is disabled");
  //   };

  //   document.addEventListener("contextmenu", detectContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   const detectDevTools = () => {
  //     const devToolsOpen = /./;
  //     devToolsOpen.toString = function () {
  //       console.log("Developer tools are disabled");
  //     };
  //     console.log(devToolsOpen);
  //   };

  //   detectDevTools();
  //   return () => {
  //     document.removeEventListener("contextmenu", detectContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const [order, setOrder] = useState([]);
  const [option, setOption] = useState("card");
  const [tableNo, setTableNo] = useState("");
  const [deliveryData, setDeliveryData] = useState({
    OrderType: "",
    customerName: "",
    customerNumber: "",
    customerAddress: "",
    DeliveryCharges: 0,
    DeliveryType: "",
  });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLoginStatus());
    dispatch(getUser());
  }, [dispatch]);
  return (
    <BrowserRouter>
      <ToastContainer />
      <div>
        <Routes>
  <Route
    path="/"
    element={
      <PublicRoute>
        <LandingPage />
      </PublicRoute>
    }
  />

  <Route
    path="/resetPassword/:resetToken"
    element={
      <PublicRoute>
        <Reset />
      </PublicRoute>
    }
  />

  <Route
    path="/login"
    element={
      <PublicRoute>
        <Login />
      </PublicRoute>
    }
  />

  <Route
    path="/forgotPassword"
    element={
      <PublicRoute>
        <Forgot />
      </PublicRoute>
    }
  />

  {/* Protected Routes */}
  <Route
    path="/createInventoryAdjustment"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <CreateInventoryAdjustment />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/tableNo"
    element={
      <ProtectedRoute>
        <TableNo setTableNo={setTableNo} />
      </ProtectedRoute>
    }
  />

  <Route
    path="/items"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <Items />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/receipts"
    element={
      <ProtectedRoute>
        <AdminCashierCounter>
          <Receipt />
        </AdminCashierCounter>
      </ProtectedRoute>
    }
  />

  <Route
    path="/kitchen-receipts"
    element={
      <ProtectedRoute>
        <AdminCashierCounter>
          <KitchenReceipt />
        </AdminCashierCounter>
      </ProtectedRoute>
    }
  />

  <Route
    path="/cashInOut/expenseItem"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <ExpenseItems />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/reports"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <Reports />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/cashInOut/expenses"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <Expenses />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/cashInOut/cashIn"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <Cashes />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/tables"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <Table />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/ingredients"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <Ingredient />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/categories"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <Category />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/createItem"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <CreateItems />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/editItem/:id"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <EditItem />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings"
    element={
      <ProtectedRoute>
        <Setting />
      </ProtectedRoute>
    }
  />

  <Route
    path="/orders"
    element={
      <ProtectedRoute>
        <Sale
          tableNo={tableNo}
          order={order}
          setOrder={setOrder}
          option={option}
          setOption={setOption}
          deliveryDatas={deliveryData}
        />
      </ProtectedRoute>
    }
  />

  <Route
    path="/query/:category"
    element={
      <ProtectedRoute>
        <ItemByCategory
          tableNo={tableNo}
          order={order}
          setOrder={setOrder}
          option={option}
          setOption={setOption}
          deliveryDatas={deliveryData}
        />
      </ProtectedRoute>
    }
  />

  <Route
    path="/completingOrder"
    element={
      <ProtectedRoute>
        <CompletingOrder />
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings/users"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <User />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings/uoms"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <UnitOfMeasure />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings/waiters"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <Waiter />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/purchases"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <Purchase />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/editPurchase/:id"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <CreatePurchase />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/createPurchase"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <CreatePurchase />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/addPurchase/:id"
    element={
      <ProtectedRoute>
        <AdminCashier>
          <AddPurchase />
        </AdminCashier>
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings/users/createUser"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <CreateUser />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings/changePassword"
    element={
      <ProtectedRoute>
        <ChangePassword />
      </ProtectedRoute>
    }
  />

  <Route
    path="/settings/users/editUser/:id"
    element={
      <ProtectedRoute>
        <OnlyAdmin>
          <EditUser />
        </OnlyAdmin>
      </ProtectedRoute>
    }
  />

  {/* <Route
            path="/query/item/:id"
            element={
              <ItemDetail
                order={order}
                setOrder={setOrder}
                option={option}
                setOption={setOption}
                deliveryDatas={deliveryData}
              />
            }
          /> */}
          {/* <Route
            path="/query/dealItem/:id"
            element={
              <DealItemDetail
                order={order}
                setOrder={setOrder}
                option={option}
                setOption={setOption}
                deliveryDatas={deliveryData}
              />
            }
          /> */}
</Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
